module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "card-list",
    attrs: {
      "xs10": "",
      "offset-xs1": "",
      "sm8": "",
      "offset-sm2": "",
      "pb-5": ""
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": ("animated " + (_vm.settingsObj.animation))
    }
  }, _vm._l((this[this.name]), function(item, i) {
    return _c('v-card', {
      key: item[item.key],
      class: ['mb-3', ((_vm.settingsObj.themeColor) + "--text"), ((_vm.settingsObj.themeColor) + " lighten-4"), 'text--darken-3', 'elevation-2'],
      attrs: {
        "transition": "slide-x-transition",
        "flat": "",
        "light": "",
        "value": _vm.name === item.name,
        "data-key": item[item.key]
      },
      on: {
        "click": function (e) {
          _vm.toggleResumeCard(item.title);
        }
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('v-layout', {
      staticClass: "full-width black--text",
      attrs: {
        "fluid": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "mb-2": "",
        "xs2": "",
        "md1": ""
      }
    }, [_c('v-avatar', {
      ref: "joe",
      refInFor: true,
      attrs: {
        "tile": true,
        "size": "50px"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "avatar"
      }
    })])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md11": "",
        "pl-2": "",
        "xs10": ""
      }
    }, [_c('div', {
      staticClass: "headline"
    }, [(_vm.isURL(item.title)) ? _c('div', {
      staticClass: "headline__text"
    }, [_c('a', {
      attrs: {
        "href": ("http://" + (item.title)),
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.title))])]) : _c('div', {
      staticClass: "headline__text"
    }, [_vm._v("\n                                    " + _vm._s(item.title) + "\n                                ")])])])], 1), _vm._v(" "), _c('v-layout', {
      staticClass: "full-width black--text",
      attrs: {
        "fluid": ""
      }
    }, [(item.company) ? _c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('div', [_vm._v(_vm._s(item.company) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (item.timeFrame) ? _c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('div', {
      staticClass: "text-align--right"
    }, [_vm._v(_vm._s(item.timeFrame) + "\n                            ")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "id": ("" + (item[item.key]))
      }
    }, [_c('v-icon', [_vm._v("\n                            " + _vm._s((_vm.expandedItem == item[item.key]) ? 'keyboard_arrow_down' : 'keyboard_arrow_up') + "\n                        ")])], 1)], 1), _vm._v(" "), _c('v-slide-y-transition', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expandedItem == item[item.key]),
        expression: "expandedItem == item[item.key]"
      }],
      staticClass: "description-text"
    }, [_c('ul', _vm._l((item.descArr), function(descItem, i2) {
      return _c('li', {
        key: descItem,
        class: ['mb-2', ((_vm.settingsObj.themeColor) + "--text"), 'text--darken-4'],
        attrs: {
          "light": ""
        }
      }, [_vm._v("\n                                " + _vm._s(descItem) + "\n                            ")])
    }))])], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fbf1deb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardList.vue
// module id = 464
// module chunks = 0